<template lang="pug">
  app-modal(
      v-if="showModalCredenciar",
      @closeModal="$emit('closeModal')",
      :titulo="'Credenciar processo - ' + numeroProcesso"
  )
    template(slot="body")
      .modal
        el-row
          el-col(:span="24")
            app-display(
                label="Nome do Interessado:",
                :content="nomeInteressado"
              )
            app-display(
                label="Nome do Responsável:",
                :content="responsavel.nome"
              )
          el-col(:span="24")
            app-display(
                label="Cpf do Responsável:",
                :content="responsavel.cpf"
              )
    template(slot="footer")
      div.flex-center
        el-button(type="primary", @click="credenciar")
          i.fal.fa-address-card.fa-lg
          span &nbsp Credenciar processo
</template>

<script>
import { mapActions } from 'vuex';
import AppModal from '@/components/AppModal';
import { AppNotificacao } from 'sicarf-components';
import AppDisplay from '@/components/AppDisplay';

export default {

  components: {
    AppModal,
    AppDisplay
  },

  mixins: [
    AppNotificacao
  ],

  data() {
    return {
      processo: null,
      responsavel: {
        nome: '',
        cpf: '',
        codigoIncra: ''
      },
      nomeInteressado: null
    }
  },

  props: {
    showModalCredenciar: {
      type: Boolean,
      default: false
    },
    numeroProcesso: {
      type: String,
    },
    protocolo: {
      type: String,
    },
  },

  async mounted() {
    if (this.protocolo) {
      this.versoes = await this.getVersoesByProtocolo(this.protocolo)
      this.versaoSelecionada = this.versoes[0]
      this.processo = await this.getProcesso(
        {
          protocolo: this.protocolo,
          versao: this.versaoSelecionada
        }
      )
      this.responsavel = this.processo.dadosCadastro.dados.cadastro.georreferenciamento.responsavel
      this.nomeInteressado = this.processo.nomeRazaoSocialInteressado
    }
  },

  methods: {
    ...mapActions({
      getProcesso: 'processos/getProcessoByProtocoloAndVersao',
      credenciarProcesso: 'processos/credenciarProcesso',
      getVersoesByProtocolo: 'processos/getVersoesByProtocolo',
    }),

    async credenciar ({row, index}) {
      this.confirmBox(this.$messages.CREDENCIAR_CONFIRM, this.$messages.TITULO_WARNING,
        async () => {
          await this.credenciarProcesso({idProcesso: this.processo.id}).then(() => {
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Processo credenciado com sucesso')
            this.$emit('refresh')
          }).catch(({ message }) => {
            this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, this.$messages.ERRO_CREDENCIAMENTO)
          }).finally(() => {
            this.$emit('closeModal')
          })
        },
        () => {
          this.responsavel = {
            nome: '',
            cpf: '',
            codigoIncra: ''
          }
          this.nomeInteressado = ''
          this.$emit('closeModal')
        })
    },
  },

  watch: {
    protocolo: async function(newVal, oldVal) {
      if (newVal) {
        this.versoes = await this.getVersoesByProtocolo(newVal)
        this.versaoSelecionada = this.versoes[0]
        this.processo = await this.getProcesso(
          {
            protocolo: newVal,
            versao: this.versaoSelecionada
          }
        )
        this.responsavel = this.processo.dadosCadastro.dados.cadastro.georreferenciamento.responsavel
        this.nomeInteressado = this.processo.nomeRazaoSocialInteressado
      }
    }
  }
}

</script>

<style scoped lang="scss">
.flex-center{
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
